import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getAllInsuredsFromParties = (parties) => {
  return filterPartiesByPartyTypeCode(parties, ["IN", "I2"]).sort((a, b) => {
    if (a.person.partyTypeCode === b.person.partyTypeCode) return 0;
    return a.person.partyTypeCode === "IN" ? -1 : 1;
  });
};
